import { createSlice } from "@reduxjs/toolkit";

import type { PayloadAction } from "@reduxjs/toolkit";
import type { LoginResponse, User, UserResponse } from "@/types/api/types.ts";
import authConfig from "@/config/auth.ts";

export type AuthState = {
  accessToken: string | null;
  refreshToken: string | null;
  user: LoginResponse["user"] | null;
  isAuthenticated: boolean;
};

const initialState: AuthState = {
  accessToken: localStorage.getItem("accessToken"),
  refreshToken: localStorage.getItem("refreshToken"),
  user: null,
  isAuthenticated: !!localStorage.getItem("accessToken"),
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    tokenReceived: (state, action: PayloadAction<{ accessToken: string }>) => {
      state.accessToken = action.payload.accessToken;
      state.isAuthenticated = true;
      localStorage.setItem("accessToken", action.payload.accessToken);
    },
    userReceived: (state, action: PayloadAction<UserResponse>) => {
      state.user = action.payload;
    },
    loggedOut: (state) => {
      state.accessToken = null;
      state.refreshToken = null;
      state.user = null;
      state.isAuthenticated = false;
      localStorage.removeItem(authConfig.storageTokenKeyName);
      localStorage.removeItem("refreshToken");
    },
  },
});

export const { tokenReceived, userReceived, loggedOut } = authSlice.actions;
export default authSlice.reducer;
